export default "__VITE_ASSET__$LJVEe5A__"